<template>
  <article>
    <div id="PRODUCT_CATALOGUE" class="container-fixed">
      <section>
        <h3><!-- #S88 -->{{ $t('substore.product_catalogue_filter_headline') }}</h3>

        <p />

        <form>
          <div class="row">
            <div class="col-l-6 col-s-12">
              <div class="form-input-set">
                <label for="filterProduct"><!-- #S91 -->{{ $t('substore.filter_products') }}</label>
                <select id="filterProduct" v-model="filterProductSelected" name="filterProduct" class="form-select" @change="applyFilter">
                  <option value=""><!-- #S92 -->{{ $t('substore.catalog_show_all_products') }}</option>
                  <option v-for="filter in filterProducts" :key="filter.id" :value="filter.id">{{ $tm('substore.filtername_', filter.id) }}</option>
                </select>
              </div>
            </div>
            <div class="col-l-6 col-s-12">
              <!-- #I55 -->
              <button type="button" class="btn btn-default pull-right" style="margin-top: 28px;" @click="resetFilter">
                <!-- #S93 -->
                {{ $t('substore.filter_reset_button') }}
              </button>
            </div>
          </div>

          <p />
        </form>
      </section>
    </div>
    <div class="container-fluid grayed-offset">
      <div class="container-fixed">
        <section>
          <h3><!-- #S94 -->{{ $t('substore.product_catalogue_products_headline') }}</h3>

          <div class="row aligncontent">
            <VProduct v-for="product in productList" :key="product.subscriptionTemplateId" v-bind="product" />
          </div>

          <InfiniteLoading ref="infiniteLoading" :identifier="infiniteId" @infinite="infiniteHandler">
            <template #no-more>
              <VEmpty />
            </template>
            <template #no-results>
              <VEmpty />
            </template>
            <template #spinner>
              <VSpinner />
            </template>
          </InfiniteLoading>

          <template v-if="isLoaded">
            <div v-if="!hasNextItems" class="h-ctr">
              {{ $tc('substore.totalProducts', totalItems) }}
            </div>
            <div v-else>
              <button type="button" class="btn btn-default" @click="infiniteHandler(null)">{{ $t('substore.loadNext') }}</button>
            </div>
          </template>
        </section>
        <p />
      </div>
    </div>
    <div v-if="hasFootnotes" class="container-fixed">
      <VFootnotes :footnotes="footnotes" />
    </div>
  </article>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import TitleMixin from '@/mixins/title';
import VProduct from '@/components/Substore/Product';
import VSpinner from '@/components/Spinner';
import VEmpty from '@/components/Empty';

export default {
  name: 'ProductCatalogue',

  components: {
    InfiniteLoading,
    VProduct,
    VSpinner,
    VEmpty,
    VFootnotes: () => import('@/components/UI/Footnotes'),
  },

  mixins: [TitleMixin],

  data() {
    return {
      infiniteId: 1,
    };
  },

  computed: {
    ...mapState('catalogue', ['productList', 'productListFiltered', 'filterProducts', 'footnotes', 'isLoaded']),
    ...mapGetters('catalogue', ['hasNextItems', 'totalItems']),

    hasFootnotes() {
      return this.footnotes && this.footnotes.hasItems();
    },

    filterProductSelected: {
      get() {
        return this.$store.state.catalogue.filterProductSelected;
      },
      set(value) {
        this.$store.dispatch('catalogue/updateProductFilter', value);
      },
    },
  },

  watch: {
    productListFiltered: 'resetInfinite',
  },

  async created() {
    await this.getProductList();
    this.$webtrekk.viewPage('produktkatalog', 'basket');
  },

  methods: {
    ...mapActions('catalogue', ['reset', 'getProductList', 'loadNext', 'resetFilter', 'applyFilter']),

    async infiniteHandler($state) {
      await this.loadNext();

      if ($state) {
        if (this.hasNextItems) {
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    resetInfinite() {
      this.infiniteId += 1;
    },
  },
};
</script>
